import * as z from 'zod';
import { Tfn } from '@jd/i18n/types';
import requireTrue from '../../../../utils/schemas/requireTrue';
import { FormField } from '../type';
import { fileFieldValidator, refineFileLimits } from './files/fileValidation';

export const generateInitialValues = (fields: FormField[] = []) => {
  return fields.reduce(
    (acc, field) => {
      if (!field?.name) return acc;
      acc[field.name] = field.blockType === 'checkbox' ? false : '';
      if (field.blockType === 'checkboxGroup' || field.blockType === 'file') {
        acc[field.name] = [];
      }
      return acc;
    },
    {} as Record<string, any>,
  );
};

export const generateStepValidationSchema = (
  fields: FormField[],
  step: number,
  common_t: Tfn<'common'>,
) => {
  const stepFields = fields.filter((f) => (f.step ?? 1) === step);
  return generateValidationSchema(stepFields, common_t);
};

export const generateValidationSchema = (
  fields: FormField[],
  common_t: Tfn<'common'>,
) => {
  const schemaShape: Record<string, z.ZodType> = {};

  fields.forEach((field) => {
    if (field.blockType === 'file') {
      schemaShape[field.name] = fileFieldValidator(field, common_t);
      return;
    }

    let validator: z.ZodTypeAny = z.string({ error: common_t('isRequired') });

    if (field.blockType === 'email')
      validator = z.email({ error: common_t('isRequired') });
    if (field.blockType === 'checkbox')
      validator = z.boolean({ error: common_t('isRequired') });

    if (field.blockType === 'checkboxGroup') {
      validator = z.array(z.any().optional());
    }
    if ('required' in field && field.required) {
      if (field.blockType === 'checkbox') {
        validator = requireTrue(common_t('isRequired'));
      }
    } else {
      validator = validator.optional();
    }

    // @ts-ignore
    schemaShape[field.name] = validator;
  });

  return z.object(schemaShape).superRefine(refineFileLimits(fields, common_t));
};
